/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCalendarProps } from './type';

export const calendarDefaultProps: TdCalendarProps = {
  format: 'YYYY-MM-DD',
  isShowWeekendDefault: true,
  mode: 'month',
  preventCellContextmenu: false,
  theme: 'full',
};
